import { configureStore } from "@reduxjs/toolkit";
import { homeAPI } from "../services/homeAPI";
import { productsAPI } from "../services/productsAPI";
import { AboutAPI } from "../services/AboutAPI";
import { contactAPI } from "../services/contactAPI";
import { productDetailAPI } from "../services/productDetailAPI";
import { AddToCartAPI } from "../services/AddToCartAPI";
import { cartPageAPI } from "../services/cartPageAPI";
import { RegisterAPI } from "../services/RegisterAPI";
import { myAccountAPI } from "../services/myAccountAPI";
import { commonAPI } from "../services/commonAPI";
import {PrivacyPolicyAPI} from "../services/PrivacyPolicyAPI"

export const store = configureStore({
  reducer: {
    [homeAPI.reducerPath]: homeAPI.reducer,
    [productsAPI.reducerPath]: productsAPI.reducer,
    [AboutAPI.reducerPath]: AboutAPI.reducer,
    [contactAPI.reducerPath]: contactAPI.reducer,
    [productDetailAPI.reducerPath]: productDetailAPI.reducer,
    [AddToCartAPI.reducerPath]: AddToCartAPI.reducer,
    [cartPageAPI.reducerPath]: cartPageAPI.reducer,
    [RegisterAPI.reducerPath]: RegisterAPI.reducer,
    [myAccountAPI.reducerPath]: myAccountAPI.reducer,
    [commonAPI.reducerPath]: commonAPI.reducer,
    [PrivacyPolicyAPI.reducerPath]: PrivacyPolicyAPI.reducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(
      homeAPI.middleware,
      productsAPI.middleware,
      AboutAPI.middleware,
      contactAPI.middleware,
      productDetailAPI.middleware,
      AddToCartAPI.middleware,
      cartPageAPI.middleware,
      RegisterAPI.middleware,
      myAccountAPI.middleware,
      commonAPI.middleware,
      PrivacyPolicyAPI.middleware
    ),
});
